<template>
  <div class="bg_white">
    <div v-if="isShow" class="">
      <div v-if="!isRegistration" class="campaign">
        <div class="campaign_image">
          <img src="@/assets/images/newyear/2023/banner.png" alt="">
        </div>
        <div v-if="available">
          <div v-if="!entered">
            <button class="entery_btn ab" @click="onClickEntry()" :class="[!entered ? 'active' : 'disable']" type="button" name="button"><span class="ab">2023年お年玉プレゼントに</span><br>応募する</button>
          </div>
          <div v-else>
            <button class="entery_btn ab disable" disabled type="button" name="button">応募済み</button>
          </div>
          <p v-if="entry_result" class="entry_message ab" :style="styleEntryMessage">{{ message }}</p>
        </div>
        <div v-else>
          <button class="entery_btn ab disable" disabled type="button" name="button">応募期間終了</button>
        </div>

        <div class="sec_wrap">
          <p class="campaign_text ar">上のボタンを押してご応募ください。抽選で10名の方に、現金1万円をプレゼントします！</p>
        </div>

        <div class="sec_wrap">
          <h2 class="sec_title ab">【応募要項】</h2>
          <p class="campaign_text ar">2023年1月15日（日）までにCONPUSのインストールと初回ログインをお済みの方に応募通知をお送りいたします。<br class="">通知にある「お年玉プレゼントに応募する」ボタンを押していただくと応募完了！</p>
          <p class="caution ar">※発表はプレゼントの発送をもってかえさせていただきます。</p>
        </div>

        <div class="sec_wrap">
          <h2 class="sec_title ab">【応募期間】</h2>
          <p class="campaign_text ar tac">2023年1月1日（日）～1月16日（月）</p>
        </div>
      </div>
      <div v-else class="registration">
        <div v-if="isLoading">
          <div class="campaign_image"><img :src="setImage()" alt=""></div>
          <div class="mt24 pl20 pr20">
            <div class="">
              <div v-if="!apiResponse.available && apiResponse.expired" class="">
                <p class="expired_text ab">エントリー期間が過ぎております</p>
              </div>
              <div v-else-if="!apiResponse.available && !apiResponse.expired" class="">
                <p class="expired_text ab">エントリーできませんでした。<br>以下の理由が考えられます。<br><br>・すでにエントリー受付済み<br>・対象製品が毎月定期購入になっていない<br><br>ご不明点はコールセンターまでお問合せ下さい。</p>
              </div>
              <div v-else class="">
                <p class="campaign_title">【新規登録キャンペーン】</p>
                <div class="text_wrap">
                  <p class="campaign_text">開催期間中に新規登録した方が対象商品を毎月定期購入にしていただくと、2か月目の製品お届け時に同じ製品をもう1つプレゼント！</p>
                  <button @click="apply()" :class="[isDisable ? 'disable' : 'active']" :disabled="isDisable" class="entery_btn ab mt16" type="button" name="button">プレゼント申し込み</button>
                  <p class="expired_text ab">{{ entryText }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Config from '@/config/config';
import Check from '@/model/getToken'
import Campaign from '@/components/api/campaign'
import CampaignNewRegistration from '@/components/api/campaign/newRegistration'

export default {
  data() {
    return {
      isShow: true,
      id: this.$route.params.id,
      isRegistration: false,
      available: true,
      entered: false,
      entry_result: false,
      styleEntryMessage: {
        color: 'red',
      },
      message: '',

      // 新規登録キャンペーン
      isDisable: false,
      entryText: '',
      isLoading: false,
      apiResponse: {
        available: false,
        campaign: {
          campaignCode: '',
          campaignName: '',
        },
        expired: false,
        imagePath: ''
      }
    }
  },
  methods: {
    onClickEntry() {
      this.entry_result = false;
      this.styleEntryMessage.color = 'red';
      Campaign.entryCampaign(this.id).then((val) => {
      // Campaign.applyCampaign(2).then((val) => {
      // Campaign.applyCampaign(3).then((val) => {
        console.log(val);
        this.message = val.message;
        this.entry_result = true;
        if(val.status == 'OK') {
          this.entered = true;
          this.styleEntryMessage.color = 'blue';
        }
      });
    },

    // 新規登録キャンペーン
    initialized() {
      this.isDisable = false;
      this.entryText = '';
      this.isLoading = false;
      this.apiResponse.available = false;
      this.apiResponse.campaign.campaignCode = '';
      this.apiResponse.campaign.campaignName = '';
      this.apiResponse.expired = false;
    },
    setData(data) {
      this.apiResponse.available = data.available;
      if(data.campaign != null) {
        this.apiResponse.campaign.campaignCode = data.campaign.campaignCode;
        this.apiResponse.campaign.campaignName = data.campaign.campaignName;
      }
      this.apiResponse.expired = data.expired;
      this.apiResponse.imagePath = data.imagePath;
    },
    setImage() {
      return Config.APIURL + this.apiResponse.imagePath;
    },
    async apply() {
      this.isDisable = true;
      console.log('キャンペーンコード');
      console.log(this.apiResponse.campaign.campaignCode);
      await CampaignNewRegistration.entryNewRegistration(this.apiResponse.campaign.campaignCode).then((val) => {
        console.log('申し込み');
        console.log(val);
        if(val.resultStatus == 'OK') {
          this.entryText = 'エントリー受付完了しました！';
        } else {
          this.isDisable = false;
          this.entryText = 'エントリーできませんでした。' + val.errorDescription;
        }
      });
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      console.log(this.$route.fullPath);
      if(this.$route.fullPath.match(/newRegistration/)) {
        this.isRegistration = true;
        this.initialized();
        await CampaignNewRegistration.getNewRegistration().then((val) => {
          console.log('新規登録キャンペーン情報');
          console.log(val);
          this.isLoading = true;
          this.setData(val);
        });
      } else {
        this.isRegistration = false;
        Campaign.getCampaign(this.id).then((val) => {
          console.log(val);
          this.entered = val.entered;
          this.available = val.available;
        });
      }
      // Campaign.getCampaign(this.id).then((val) => {
      //   console.log(val);
      //   this.entered = val.entered;
      //   this.available = val.available;
      // });
    } else {
      this.isShow = false;
    }
  }
}
</script>
<style lang="css" scoped>
.expired {
  position: relative;
}
.expired::before {
  background-color: rgba(0, 0, 0, .6);
  opacity: .8;
  content: '';
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
}

.bg_white {
  background-color: #fff;
}

.campaign_image {
  width: 100%;
}

.sec_wrap {
  margin-top: 24px;
  padding: 0 20px;
}
.sec_title {
  text-align: center;
}

.campaign_text {
  font-size: 14px;
  margin: 10px 0;
}

.entery_btn {
  border: none;
  border-radius: 10px;
  display: block;
  font-size: 16px;
  line-height: 1.3;
  margin: 16px auto 0;
  padding: 5px 0;
  text-align: center;
  width: 80%;
}
.entery_btn span {
  font-size: 12px;
}
.entery_btn.active {
  background-color: #00AEEF;
  color: #fff;

}
.entery_btn.disable {
  background-color: #595959;
  color: #fff;
  padding: 15px 0;
}

.entry_message {
  font-size: 16px;
  margin-top: 16px;
  padding: 0 20px;
  text-align: center;
}
.caution {
  font-size: 10px;
  margin-top: 5px;
}
.tac {
  text-align: center;
}



.registration .text_wrap {
  margin-top: 32px;
}
.registration .entery_btn {
  border: none;
  border-radius: 10px;
  font-size: 18px;
  line-height: 1.3;
  padding: 15px 0;
  text-align: center;
  width: 100%;
}
.registration .entery_btn span {
  font-size: 12px;
}
.registration .entery_btn.active {
  background-color: #ffc000;
  color: #000;
}
.registration .entery_btn.disable {
  background-color: #595959;
  color: #fff;
}

.registration .expired_text {
  color: red;
  margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/views/campaign/campaign.vue